<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><h1 class="introduction-title"><img alt="" src="images/h.jpg"/> P<span class="small">HOTOGRAPHS</span> <img alt="" src="images/h1.jpg"/></h1>
<p class="noindent0"><span class="small">P</span>age iii</p>
<p class="noindent">Secretariat winning his second race—by six lengths.</p>
<p class="noindent2"><span class="small">P</span>age 1</p>
<p class="noindent">Secretariat on the plane heading for Claiborne Farm on November 11, 1973. Worried by</p>
<p class="noindent">the engine’s roar, he grips the jacket of his groom, Edward “Shorty” Sweat, with his teeth.</p>
<p class="noindent2"><span class="small">P</span>age 17</p>
<p class="noindent">Eddie appears to be chatting up the big red horse before his last race, at Woodbine Racetrack in Toronto.</p>
<p class="noindent2"><span class="small">P</span>age 51</p>
<p class="noindent">Eddie Sweat looking happy and relaxed at his home away from home—the backstretch.</p>
<p class="noindent2"><span class="small">P</span>age 87</p>
<p class="noindent">Secretariat as a foal. He was bigger and more muscled than most.</p>
<p class="noindent2"><span class="small">P</span>age 103</p>
<p class="noindent">Secretariat nuzzles Eddie Sweat while Riva Ridge looks on.</p>
<p class="noindent2"><span class="small">P</span>age 143</p>
<p class="noindent">Ed Bogucki’s bronze was unveiled in Lexington, Kentucky, on July 17, 2004. The life-sized bronze depicts Secretariat, jockey Ron Turcotte, and groom Eddie Sweat just moments after the Derby win.</p>
<p class="noindent2"><span class="small">P</span>age 187</p>
<p class="noindent">The brass plates on Secretariat’s old stall at Claiborne Farm near Paris, Kentucky.</p>
<p class="noindent2"><span class="small">P</span>age 223</p>
<p class="noindent">The metal plate on the grave of Eddie Sweat near Holly Hill, South Carolina.</p>
<p class="noindent2"><span class="small">P</span>age 249</p>
<p class="noindent">Secretariat crosses the finish line at Woodbine on October 28, 1973.</p>
<p class="noindent2"><span class="small">P</span>age 281</p>
<p class="noindent">Eddie Sweat struggles with his emotions on the day he hands over Secretariat to his new</p>
<p class="noindent">keepers at Claiborne Farm near Paris, Kentucky.</p>
<p class="noindent2"><span class="small">P</span>age 311</p>
<p class="noindent">Eddie Sweat eyes Secretariat while the horse eyes the photographer on the grass behind the</p>
<p class="noindent">track.</p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?89332260